import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DataContext from './context/DataContext';
import { Layout } from './components';
import {
  AboutPage,
  BlogCloudservice,
  BlogPage,
  BlogTomcat,
  ContactPage,
  FellowshipPage,
  HomePage,
  MVPPage,
  OurProjectsPage,
  PrivacyPolicy,
  ServicePage,
  TenDaysMVPPage,
  Termsandcondition
} from './pages';

import BlogDocker from './pages/BlogDocker/BlogDocker';
import {
  CatalystPage,
  OneTNPage,
  OpenInnovationPage,
  PaarrEverPage,
  StartupTNPage,
  TanfundPage
} from './sections';

const Baseroute = () => {
  console.log(Router);

  const { pageLoading } = useContext(DataContext);
  return (
    <div>
      {pageLoading && (
        <div className="loader_div">
          <div className="ring"></div>
          <div className="ring"></div>
          <div className="ring"></div>
        </div>
      )}
      <main>
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* <Route path="/home" index element={<HomePage />} /> */}
            <Route path="/" index element={<HomePage />} />
            <Route path="/about" index element={<AboutPage />} />
            <Route path="/service" index element={<ServicePage />} />
            <Route path="/works" index element={<OurProjectsPage />} />
            <Route path="/works/startuptn" index element={<StartupTNPage />} />
            <Route path="/works/catalyst" index element={<CatalystPage />} />
            <Route path="/works/onetn" index element={<OneTNPage />} />
            <Route
              path="/works/openinnovation"
              index
              element={<OpenInnovationPage />}
            />
            <Route path="/works/paarrever" index element={<PaarrEverPage />} />
            <Route path="/works/tanfund" index element={<TanfundPage />} />
            <Route path="/blog" index element={<BlogPage />} />
            <Route
              path="/blog/cloud-service"
              index
              element={<BlogCloudservice />}
            />
            <Route
              path="/blog/springboot-tomcat"
              index
              element={<BlogTomcat />}
            />
            <Route
              path="/blog/springboot-docker"
              index
              element={<BlogDocker />}
            />
            <Route path="/two-days-mvp" index element={<MVPPage />} />
            <Route path="/ten-days-mvp" index element={<TenDaysMVPPage />} />
            <Route path="/contact" index element={<ContactPage />} />
            <Route path="/privacypolicy" index element={<PrivacyPolicy />} />
            <Route
              path="/termsandconditions"
              index
              element={<Termsandcondition />}
            />
            <Route path="/fellowship" index element={<FellowshipPage />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
};

export default Baseroute;
